/** Send a complete settlement once; never settle all orders per tender. */
export function submitTableSettlement(authAxios, tableId, amount, discount, method, options = {}) {
  return authAxios.post(`/tables/${tableId}/payment`, {
    amount, discount_applied: discount, method, ...options,
  });
}

export function tablePaymentError(detail) {
  if (!detail) return null;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map(x => x?.msg || JSON.stringify(x)).join("; ");
  return JSON.stringify(detail);
}

